import { Button } from 'antd';

import { ReactComponent as CheckedSvg } from 'assets/svg-icons/style-checked.svg';

import { ReactComponent as CircleLeftSvg } from 'assets/svg-icons/style-circle-left.svg';
import { ReactComponent as CircleRightSvg } from 'assets/svg-icons/style-circle-right.svg';
import { STYLED_BTN } from './constants';

const PermissionGroupButton = (props) => {
  const { text, style, type, isDisabledBtn, ...restProps } = props;

  const renderIconByType = () => {
    if (type === 'add') return <CircleRightSvg />;

    if (type === 'remove') return <CircleLeftSvg />;

    return <CheckedSvg />;
  };

  return (
    <Button
      style={{
        ...STYLED_BTN,
      }}
      shape='circle'
      className='role-permission-group__title-get-all'
      icon={renderIconByType(type)}
      {...restProps}
    />
  );
};

export default PermissionGroupButton;
